export default "__VITE_ASSET__CSJ6Q3Pb__"